import React from "react";
import moment from "moment";
import Button from "../../../components/buttons";
import { createConfirmation, confirmable } from "../../../hooks/DialogMountPoint";
import { Modal } from "react-bootstrap";
import { DateDisplay } from "../../../components";
import { ValuationDatePicker } from "./ValuationBuildPicker";
import { ModalConfirmationWithReturn } from "../../../types/DefModalOptions";
import ThemedModal from "../../../components/utilities/ThemedModal";


export type ValuationDateConfirmModalProps = ModalConfirmationWithReturn<moment.Moment, string>;
const ValuationDateConfirmModal = ({ 
    backdrop = 'static',
    cancel,
    centered = true,
    defaultValues,
    dialogId,
    dismiss,
    proceed,
    show,
    size = "lg",
    ...rest
} : Readonly<ValuationDateConfirmModalProps>) => {
    const displayDate = defaultValues ?? moment();
    const [selectedDate, setSelectedDate] = React.useState<string>(defaultValues ? defaultValues.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'));

    const onClose = () => cancel!();

    const onConfirm = () => proceed!(selectedDate);

    return (
        <Modal backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header>
                <Modal.Title>Confirm Valuation Date</Modal.Title>
            </ThemedModal.Header>
            <Modal.Body>
                <p>Are you sure you want to start a valuation build for <DateDisplay format="Do MMMM YYYY">{displayDate}</DateDisplay>? Select a different date below to change.</p>
                <div className="row-cols-3">
                    <ValuationDatePicker
                        value={selectedDate}
                        setValue={setSelectedDate}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" type="submit" onClick={onConfirm}>Start Build</Button>
                <Button variant="light" onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}

export function openValuationDateConfirmationModal(defaultDate: moment.Moment) {
    return createConfirmation<ValuationDateConfirmModalProps, string>(confirmable(ValuationDateConfirmModal))({
        dialogId: 'confirm_valuation_build_date_modal',
        defaultValues: defaultDate
    });
}

export default ValuationDateConfirmModal;